import { PIN_LENGTH } from '@consts/location';

import type { LocationState } from '@/types/locations';

const EMAIL_REGEX = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const validateEmail = (email: string) => {
    if (email && !EMAIL_REGEX.test(email)) {
        return { error: true, message: 'Please enter a valid email address' };
    } else if (!email) {
        return { error: true, message: 'Please enter an email address' };
    } else {
        return { error: false, message: '' };
    }
};

const isFalsy = (x: any) => {
    if (x) {
        return false;
    }
    return true;
};

export const validatePin = (pin: string) => {
    return pin?.length === PIN_LENGTH && !/^0/.test(pin) && /^\d+$/.test(pin);
};

export const validatePassword = (password?: string, match?: string) => {
    switch (true) {
        case isFalsy(password):
            return { error: true, message: 'Password is Required' };
        case (password as string)?.length < 6:
            return { error: true, message: 'Password must be at least 6 characters' };
        case match && password !== match:
            return { error: true, message: 'Passwords do not match' };
        default:
            return { error: false, message: '' };
    }
};

export namespace Validate {
    export const name = (name: string) => Boolean(name?.trim().length);

    export namespace Auth {
        export const email = (email: string) => Boolean(email && EMAIL_REGEX.test(email));

        export const password = (password: string) => password.length >= 6;

        export const user = (user: any) => {
            const { given_name, family_name, email: userEmail } = user ?? {};

            return name(given_name) && name(family_name) && email(userEmail);
        };
    }

    export namespace Org {
        export const location = (locationState: LocationState) => {
            return (
                name(locationState?.LocationName) &&
                locationState?.CompanyID !== null &&
                Boolean(locationState?.Country) &&
                validatePin(locationState?.PIN)
            );
        };

        export const reseller = (resellerState: any = {}) => {
            const { CompanyName, ResellerCompanyID, CutPlanID, WarrantyPlanID } = resellerState;

            return name(CompanyName) && ResellerCompanyID !== null && CutPlanID !== null && WarrantyPlanID !== null;
        };

        export const company = (companyState: any = {}) => {
            const { CompanyName, CutPlanID, WarrantyPlanID, CustomerID } = companyState;

            return name(CompanyName) && CutPlanID !== null && WarrantyPlanID !== null && Boolean(CustomerID);
        };
    }

    export const system = (systemState: any = {}) => {
        return Boolean(systemState?.Status) && ['CompanyID', 'LocationID'].every((key) => key in systemState);
    };

    export namespace Cut {
        export const id = (val: string) => /^[0-9A-F]+-.+$/.test(val);
    }
}
